module.exports = __webpack_public_path__ + "static/media/portfolio1.38b1b63f.jpg";